<template>
<div class="payment-bonuses">
  <div class="payment-bonuses_block">
    <div class="payment-bonuses_item" v-if="dictionaryBonusPrograms.cashBack">
      <div class="payment-bonuses_item-inner">
        <div class="payment-bonuses_item-indicator">
          <v-checkbox
            class="ui-checkbox"
            v-model="selectedProgram"
            value="mir"
            hide-details
          />
        </div>
        <div class="payment-bonuses_item-logo">
          <img class="payment-bonuses_item-logo-img" src="@/assets/img/bonusProgramsLogo/mir.png" alt="Логотип 'Мир'">
        </div>

        <div class="payment-bonuses_item-body">
          <span class="payment-bonuses_item-name">
            Регистрируйтесь в "Привет, мир!" и получайте кэшбек.
            Подробнее Вы можете узнать <a href="https://xn--b1afakdgpzinidi6e.xn--p1ai/" target="_blank">здесь</a>
          </span>
        </div>
      </div>

      <span class="payment-bonuses_item-notification">
        *Бонусы будут начислены только при оплате картой,
        зарегистрированной в программе “Привет, мир!”
      </span>
    </div>

    <div class="payment-bonuses_item payment-bonuses_uds" v-if="dictionaryBonusPrograms.uds && +selectedVariant.divisionId !== 2">
      <div class="payment-bonuses_item-inner">
        <div class="payment-bonuses_item-indicator">
          <v-checkbox
            class="ui-checkbox"
            v-model="selectedProgram"
            value="uds"
            :disabled="!isUdsAvailable || disabled"
            hide-details
          />
        </div>
        <div class="payment-bonuses_item-logo">
          <img class="payment-bonuses_item-logo-img" src="@/assets/img/bonusProgramsLogo/uds.png" alt="Логотип 'UDS'">
        </div>

        <div class="payment-bonuses_item-body">
          <span class="payment-bonuses_item-name">
            Получайте баллы UDS и тратьте их вместе со скидками.*
          </span>
        </div>

        <div
          class="payment-bonuses_item-controls"
          :class="{
            'payment-bonuses_item-controls--disabled': !udsData.isSelected || !isUdsAvailable || disabled,
          }"
        >
          <div class="payment-bonuses_item-unapplied" v-if="!udsData.isApplied">
            <a
              class="payment-bonuses_action ui-btn ui-btn--darkgreen"
              href="javascript:void(0)"
              @click.prevent="applyUds"
            >
              Применить бонусы
            </a>
          </div>

          <div class="payment-bonuses_item-applied" v-else>
            <span class="payment-bonuses_item-applied-text">
              {{dispUdsBonusesValue}}
            </span>

            <a href="javascript:void(0)" class="payment-bonuses_unapply-btn" @click="unapplyUdsBonuses" v-if="!disabled">
              <icon-cross class="ui-icon" />
            </a>
          </div>
        </div>
      </div>

      <span class="payment-bonuses_item-notification">
        * При использовании услуги рассрочки или кредита, баллы по системе лояльности UDS не начисляются.
      </span>
    </div>
  </div>

  <div class="payment-bonuses_block">
    <span class="payment-bonuses_block-title">Варианты оплаты</span>

    <v-radio-group
      class="payment-bonuses_prepayment"
      v-model="prepaymentType"
    >
      <div class="payment-bonuses_prepayment-item" v-if="!isPresent">
        <div class="payment-bonuses_prepayment-item-control">
          <v-radio
            class="payment-bonuses_prepayment-item-radio"
            value="prepayment"
            label="Предоплата 10%"
            :disabled="!isPrepaymentAvailable || disabled"
          />
        </div>

        <div class="payment-bonuses_prepayment-item-details">
          <span>(Вам будет предоставлена бронь)</span>
        </div>
      </div>

      <div class="payment-bonuses_prepayment-item">
        <div class="payment-bonuses_prepayment-item-control">
          <v-radio
            class="payment-bonuses_prepayment-item-radio"
            value="full_price"
            label="Предоплата 100%"
            :disabled="disabled"
          />
        </div>

        <div class="payment-bonuses_prepayment-item-details" v-if="udsData.data.cashBack">
          <span>(+ начислено {{udsData.data.cashBack}} UDS)</span>
        </div>
      </div>

      <div class="payment-bonuses_prepayment-item">
        <div class="payment-bonuses_prepayment-item-control">
          <v-radio
            class="payment-bonuses_prepayment-item-radio"
            value="credit"
            label="Предоплата 100% (в рассрочку)"
            :disabled="!isCreditAvailable || disabled"
          />
        </div>
      </div>
    </v-radio-group>
  </div>

  <v-dialog
    max-width="662"
    v-model="isUdsDialogShowed"
    style="z-index:1002"
  >
    <ui-dialog
      @close="isUdsDialogShowed = false"
      :noHeader="true"
      :mobileContentAlign="'top'"
    >
      <uds-bonuses
        @dialogClose="isUdsDialogShowed = false"
      />
    </ui-dialog>
  </v-dialog>
</div>
</template>

<script>
import UDSBonuses from '@/components/UDSBonuses'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'

export default {
  name: 'payment-bonuses',
  props: ['disabled'],

  components: {
    'uds-bonuses': UDSBonuses,
  },

  data: () => ({
    selectedProgram: null,
    // isUdsDisabled: false,
    isUdsDialogShowed: false,
    paymentTypeInherit: 'full_price',
  }),

  computed: {
    ...mapState({
      dictionaryBonusPrograms: state => state.dictionaries.loyaltyPrograms,
      storeLoyaltyPrograms: state => state.loyalty.programs,
      // storeIsPrepayment: state => state.selection.isPrepayment,
      savedBookingInfo: state => state.selection.savedBookingInfo,
      paymentMethodVal: state => state.selection.paymentMethod,
      certificates: state => state.selection.certificates,
    }),

    ...mapGetters({
      getUdsData: 'loyalty/getUdsData',
      getIsPresent: 'selection/getIsPresent',
      getIsPrepayment: 'selection/getIsPrepayment',
      selectedVariant: 'selection/getSelectedCategory'
    }),

    prepaymentType: {
      get() {
        return this.paymentTypeInherit
      },
      set(value) {
        this.paymentTypeInherit = value
        switch(value) {
          case 'full_price':
            this.setPaymentMethod('ukassa')
            this.isPrepayment = false
            break
          case 'prepayment':
            this.isPrepayment = true
            this.setPaymentMethod('ukassa')
            break
          case 'credit':
            this.isPrepayment = false
            this.setPaymentMethod('credit')
            break
        }
      },
    },

    isPrepayment: {
      get() {
        return this.getIsPrepayment;
      },
      set(value) {
        this.storeSetIsPrepayment(value);
      },
    },

    isPresent() {
      return this.getIsPresent;
    },

    mirData() {
      return this.storeLoyaltyPrograms.find(obj => obj.id === 'mir')
    },

    udsData() {
      return this.storeLoyaltyPrograms.find(obj => obj.id === 'uds')
    },

    dispUdsBonusesValue() {
      if(!this.udsData.isApplied) { return }
      let str = ''

      if(this.udsData.data.code) {
        str += `Будет списано: ${this.udsData.data.canWrite}`
        if((+this.udsData.data.canWrite % 10 === 1) && (+this.udsData.data.canWrite !== 11)) str += ` бонус`
        else if(+this.udsData.data.canWrite > 1 && +this.udsData.data.canWrite < 5) str += ` бонуса`
        else str += ` бонусов`
      } else {
        str = `Бонусы будут начислены после оплаты`
      }

      return str
    },

    isUdsAvailable() {
      let res = true
      if(this.paymentMethodVal === `credit` || this.paymentMethodVal === `installment` || this.isPrepayment || this.certificates.length) {
        res = false
      }
      return res
    },

    isPrepaymentAvailable() {
      let res = true
      let isUdsApplied = Object.keys(this.getUdsData).length
      if(this.paymentMethodVal === `credit` || this.paymentMethodVal === `installment` || this.certificates.length || isUdsApplied) {
        res = false
      }
      return res
    },

    isCreditAvailable() {
      let res = true
      let isUdsApplied = Object.keys(this.getUdsData).length
      if(this.paymentMethodVal === `credit` || this.paymentMethodVal === `installment` || this.certificates.length || isUdsApplied) {
        res = false
      }
      return res
    },
  },

  methods: {
    ...mapMutations({
      storeSetIsPrepayment: 'selection/setIsPrepayment',
      setIsLoading: 'setIsLoading',
      setPaymentMethod: 'selection/setPaymentMethod',
    }),

    ...mapActions({
      updateBonusProgram: 'loyalty/updateBonusProgram',
      updateSavedBookingInfo: 'selection/updateSavedBookingInfo',
    }),

    applyUds() {
      if(!this.isUdsAvailable) return
      this.isUdsDialogShowed = true
    },

    unapplyUdsBonuses() {
      this.setIsLoading(true)

      this.pointsRequest()

      this.updateBonusProgram({
        id: 'uds',
        data: {
          isApplied: false,
          data: {},
        },
      })
    },

    pointsRequest() {
      this.$http
        .post(`/payment/sbp/generatePoints/`, { // solar:booking.api.points
          clusterId: this.savedBookingInfo.clusterId,
          rsvPersonId: this.savedBookingInfo.rsvPersonId,
          requestId: this.savedBookingInfo.requestId,
          loyaltyPoints: 0,
          price: this.savedBookingInfo.price,
          primaryPrice: this.savedBookingInfo.primaryPrice,
          sbp: this.savedBookingInfo.sbp,
          ticketPrice: this.savedBookingInfo.ticketPrice,
        })
        .then((resp) => {
          this.updateSavedBookingInfo({
            paymentPrice: this.savedBookingInfo.price,
            sbp: {...this.savedBookingInfo.sbp, ...resp.data.data.sbp},
            loyaltyPointsUds: resp.data.data.loyaltyPointsUds,
          })
        })
        .finally(() => {
          this.setIsLoading(false)
        })
    }
  },

  watch: {
    selectedProgram(value, oldValue) {
      this.storeLoyaltyPrograms.forEach(program => {
        let obj = {
          id: program.id,
          data: {
            isSelected: (value === program.id) ? true : false,
          },
        }

        this.updateBonusProgram(obj)
      })

      if(oldValue === `uds` && this.udsData.isApplied) {
        this.unapplyUdsBonuses()
      }
    },

    isUdsAvailable(v) {
      if(!v && this.udsData.isApplied) {
        this.unapplyUdsBonuses()
        let updateObj = {
          isApplied: false
        }
        if(this.udsData.isSelected) {
          updateObj.isSelected = false
          this.selectedProgram = null
        }
        this.updateBonusProgram({
          id: 'uds',
          data: updateObj,
        })
      }
    }
  },

  created() {
    let selectedProgram = this.storeLoyaltyPrograms.find(obj => obj.isSelected === true)
    this.selectedProgram = selectedProgram ? selectedProgram.id : null
  },
}
</script>

<style lang="sass">
.payment-bonuses_item
  width: 100%

  + .payment-bonuses_item
    margin-top: px-em(50)

.payment-bonuses_item-inner
  width: 100%
  display: flex
  align-items: center

.payment-bonuses_item-indicator
  flex-shrink: 0
  margin-right: px-em(20)

.payment-bonuses_item-logo
  display: flex
  flex-shrink: 0
  width: px-em(50)
  margin-right: px-em(15)

.payment-bonuses_item-logo-img
  max-width: 100%
  flex-shrink: 0

.payment-bonuses_item-body
  flex-grow: 1
  min-width: 1px
  display: flex

.payment-bonuses_item-controls
  flex-shrink: 0
  position: relative

  &::before
    content: ''
    display: none
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    background-color: rgba(255,255,255, .5)
    // pointer-events: none
    z-index: -1

  &--disabled

    &::before
      display: block
      z-index: 10

.payment-bonuses_item-name
  display: block

.payment-bonuses_item-applied
  display: flex
  align-items: center

.payment-bonuses_unapply-btn,
.v-application .payment-bonuses_unapply-btn
  color: #C01717

.payment-bonuses_unapply-btn
  display: inline-block
  vertical-align: top
  line-height: 1.2
  margin-left: px-em(22)

.payment-bonuses_item-notification
  display: block
  font-size: px-em(11)

.payment-bonuses_block

  + .payment-bonuses_block
    margin-top: 50px
    padding-top: 50px
    border-top: 1px solid #8A8A8A

.payment-bonuses_block-title
  font-size: px-em(18)
  font-weight: 500
  display: block
  margin-bottom: px-em(40, 18)

.payment-bonuses_prepayment-item

  + .payment-bonuses_prepayment-item
    margin-top: px-em(50)

.payment-bonuses_prepayment-item-radio
  label.v-label
    font-weight: 400
    color: rgba(0, 0, 0, 0.87)

.payment-bonuses_prepayment-item-details
  font-size: px-em(11)
  margin-top: px-em(15, 11)

@media screen and (max-width: $mobile-breakpoint)
  .payment-bonuses_item
    + .payment-bonuses_item
      margin-top: px-em(40,12)

  .payment-bonuses_item-inner
    align-items: flex-start

  .payment-bonuses_item-logo
    width: px-em(40,12)
    // max-height: px-em(20)
    justify-content: center
    padding-top: px-em(2,12)

  .payment-bonuses_item-indicator
    margin-right: 0

  .payment-bonuses_uds
    padding-bottom: px-em(58,12)
    position: relative

    .payment-bonuses_item-controls
      position: absolute
      bottom: 0
      left: 0
      right: 0
      min-height: px-em(42,12)
      display: flex
      align-items: center

  .payment-bonuses_item-applied
    width: 100%

  .payment-bonuses_unapply-btn
    margin-left: auto

  .payment-bonuses_item-indicator
    .v-input
      margin-top: 0
      padding-top: 0
      // padding-top: px-em(0,12)

  .payment-bonuses_item-notification
    font-size: px-em(10,12)
    margin-top: px-em(8,12)

  .payment-bonuses_item-unapplied
    width: 100%
</style>
